import { GridAlignment } from "@mui/x-data-grid";
import { CSSProperties } from "react";
import { Box, Tooltip } from "src/components/MuiGenerals";

type AggregationRowField = {
  field: string;
  value: React.ReactNode;
  width: CSSProperties["width"];
  align: GridAlignment;
  height: CSSProperties["height"];
  padding: CSSProperties["padding"];
  hasTooltip: boolean;
  color: CSSProperties["color"];
};

function AggregationRow({ fields }: { fields: AggregationRowField[] }) {
  const getJustifyContent = (align: GridAlignment) => {
    switch (align) {
      case "left":
        return "flex-start";
      case "right":
        return "flex-end";
      case "center":
      default:
        return "center";
    }
  };

  return (
    <Box
      sx={{
        position: "sticky",
        display: "flex",
        bottom: 0,
        backgroundColor: "#F1F2F4",

        ":before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 5,
          width: "calc(100% - 10px)",
          height: "1px",
          backgroundColor: "#ccc",
        },
      }}
    >
      {fields.map(({ value, align, hasTooltip = false, ...style }, index) => {
        return (
          <div
            key={index}
            style={{
              ...style,
              boxSizing: "border-box",
              display: "flex",
              alignItems: "center",
              justifyContent: getJustifyContent(align),
            }}
          >
            <Tooltip title={hasTooltip ? value : ""}>
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  color: style.color,
                }}
              >
                {value}
              </div>
            </Tooltip>
          </div>
        );
      })}
    </Box>
  );
}

export default AggregationRow;
